// src/components/auth/RoleProtectedRoute.tsx
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Layout } from '../layout/Layout';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  requiredRole: string;
}

export function RoleProtectedRoute({ children, requiredRole }: RoleProtectedRouteProps) {
  const { isAuthenticated, hasRole } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  if (!hasRole(requiredRole)) {
    // Redirect to unauthorized page or dashboard with limited access
    return <Navigate to="/unauthorized" />;
  }

  return <Layout>{children}</Layout>;
}